import { render, staticRenderFns } from "./EmailRegister.vue?vue&type=template&id=f1ecef96&"
import script from "./EmailRegister.vue?vue&type=script&lang=js&"
export * from "./EmailRegister.vue?vue&type=script&lang=js&"
import style0 from "./EmailRegister.vue?vue&type=style&index=0&id=f1ecef96&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports